<template>
  <slot />
</template>

<script>
export default {
  name: "DefaultLayout",
};
</script>

<style scoped lang="scss"></style>
